const OpposingArrowsHorizontal = () => (
  <>
    <path
      fill="currentColor"
      d="m5.921 15.996 2.746 2.747a.48.48 0 0 1-.006.707.52.52 0 0 1-.353.163.49.49 0 0 1-.354-.163l-3.389-3.388a.8.8 0 0 1-.183-.268.8.8 0 0 1-.053-.298q0-.161.053-.298a.8.8 0 0 1 .183-.267l3.389-3.388a.5.5 0 0 1 .341-.15.48.48 0 0 1 .366.15q.165.165.166.356a.5.5 0 0 1-.166.357l-2.74 2.74H18.5q.213 0 .357.144a.48.48 0 0 1 .143.356.48.48 0 0 1-.143.357.48.48 0 0 1-.357.143zm12.158-7H5.5a.48.48 0 0 1-.357-.143A.48.48 0 0 1 5 8.496q0-.213.143-.356a.48.48 0 0 1 .357-.144h12.579L15.333 5.25a.48.48 0 0 1 .006-.708.52.52 0 0 1 .353-.162.49.49 0 0 1 .354.163l3.389 3.388a.8.8 0 0 1 .183.267q.054.136.053.298a.8.8 0 0 1-.053.298.8.8 0 0 1-.183.268l-3.389 3.388a.5.5 0 0 1-.341.15.48.48 0 0 1-.367-.15.5.5 0 0 1-.165-.357q0-.19.165-.356z"
    />
  </>
)
export default OpposingArrowsHorizontal
